import { Box, Alert } from "@mui/material";
import GlobalStyles from "@mui/material/GlobalStyles";
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import NavTabs from "../../../../../components/Tabs/NavTabs";
import EstimationBOMTab from "./EstimationBOM";
import EstimationSummaryTab from "./Tank_Estimation_Summary";
import EstimationTab from "./Tank_Estimation";
import { Piping } from "../../../Ams/Piping/Index";
import { Instrumentation } from "../../../Ams/Instrumentation/Index";
import { GeneralProvider } from "../../../AllEquipments/CommonFeatures/SidePanel/GeneralContext";
import PVModeling from "../../../Ams/PV3/index";
import { Modeling } from "../../../Ams/Structural/Modeling";
import useModuleAccess from "../../../../../hooks/useModuleAccess";
import {
  APP_MODULES,
  filterEstimationTabsByLicence,
} from "../../../../../constants/appModules";

const autoResizeTabsSx = {
  width: "100%",

  "& .MuiTabs-root": {
    minHeight: "0px !important",
    height: "auto !important",
  },

  "& .MuiTabs-scroller": {
    minHeight: "0px !important",
    height: "auto !important",
  },

  "& .MuiTabs-flexContainer": {
    minHeight: "0px !important",
    height: "auto !important",
    alignItems: "center !important",
  },

  "& .MuiTabs-scrollButtons": {
    minHeight: "0px !important",
    height: "auto !important",
    width: "26px !important",
  },

  "& .MuiTabs-indicator": {
    height: "2px !important",
  },

  "& .MuiTab-root": {
    minHeight: "0px !important",
    height: "auto !important",
    paddingTop: "6px !important",
    paddingBottom: "6px !important",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    fontSize: "12px !important",
    fontWeight: "600 !important",
    lineHeight: "1.2 !important",
    textTransform: "none !important",
  },

  "& .MuiTab-iconWrapper": {
    marginBottom: "0px !important",
  },

  "& .MuiButton-root": {
    minHeight: "0px !important",
    height: "auto !important",
    paddingTop: "5px !important",
    paddingBottom: "5px !important",
    paddingLeft: "10px !important",
    paddingRight: "10px !important",
    fontSize: "12px !important",
    lineHeight: "1.2 !important",
    textTransform: "none !important",
  },

  "& .MuiInputBase-root": {
    minHeight: "0px !important",
    height: "auto !important",
    fontSize: "12px !important",
    lineHeight: "1.2 !important",
  },

  "& .MuiInputBase-input": {
    paddingTop: "6px !important",
    paddingBottom: "6px !important",
    fontSize: "12px !important",
    lineHeight: "1.2 !important",
  },

  "& .MuiOutlinedInput-root": {
    minHeight: "0px !important",
    height: "auto !important",
  },

  "& .MuiSelect-select": {
    minHeight: "0px !important",
    paddingTop: "6px !important",
    paddingBottom: "6px !important",
    display: "flex !important",
    alignItems: "center !important",
  },

  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    minHeight: "0px !important",
    height: "auto !important",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
  },

  "& .MuiAutocomplete-root .MuiAutocomplete-input": {
    paddingTop: "6px !important",
    paddingBottom: "6px !important",
    fontSize: "12px !important",
    lineHeight: "1.2 !important",
  },

  "& .MuiAutocomplete-endAdornment": {
    top: "50% !important",
    transform: "translateY(-50%) !important",
  },

  "& .MuiInputLabel-root": {
    fontSize: "11px !important",
    lineHeight: "1.2 !important",
  },

  "& .MuiFormControl-root": {
    minHeight: "0px !important",
  },

  "& .MuiToolbar-root": {
    minHeight: "0px !important",
    height: "auto !important",
    paddingTop: "4px !important",
    paddingBottom: "4px !important",
  },

  "& .MuiStack-root": {
    minHeight: "0px",
  },
};

const mainEquipmentTabsSx = {
  "& > .MuiTabs-root, & > .MuiBox-root > .MuiTabs-root, & > div > .MuiTabs-root, & > div > .MuiBox-root > .MuiTabs-root":
    {
      minHeight: "40px !important",
      height: "auto !important",
    },

  "& > .MuiTabs-root .MuiTabs-scroller, & > .MuiBox-root > .MuiTabs-root .MuiTabs-scroller, & > div > .MuiTabs-root .MuiTabs-scroller, & > div > .MuiBox-root > .MuiTabs-root .MuiTabs-scroller":
    {
      minHeight: "40px !important",
      height: "auto !important",
    },

  "& > .MuiTabs-root .MuiTabs-flexContainer, & > .MuiBox-root > .MuiTabs-root .MuiTabs-flexContainer, & > div > .MuiTabs-root .MuiTabs-flexContainer, & > div > .MuiBox-root > .MuiTabs-root .MuiTabs-flexContainer":
    {
      minHeight: "40px !important",
      height: "auto !important",
      alignItems: "center !important",
    },

  "& > .MuiTabs-root .MuiTab-root, & > .MuiBox-root > .MuiTabs-root .MuiTab-root, & > div > .MuiTabs-root .MuiTab-root, & > div > .MuiBox-root > .MuiTabs-root .MuiTab-root":
    {
      minHeight: "40px !important",
      height: "auto !important",
      paddingTop: "10px !important",
      paddingBottom: "10px !important",
      paddingLeft: "16px !important",
      paddingRight: "16px !important",
      fontSize: "13px !important",
      fontWeight: "700 !important",
      lineHeight: "1.2 !important",
      textTransform: "none !important",
    },

  "& > .MuiTabs-root .MuiTabs-indicator, & > .MuiBox-root > .MuiTabs-root .MuiTabs-indicator, & > div > .MuiTabs-root .MuiTabs-indicator, & > div > .MuiBox-root > .MuiTabs-root .MuiTabs-indicator":
    {
      height: "2.5px !important",
    },
};

const Estimation = (props) => {
  const { hasModule } = useModuleAccess();
  const [searchParams] = useSearchParams();

  // Set by the EMS tree's deep links: a WBS belongs to exactly one discipline,
  // so once one is picked the other equipment tabs are noise - the tree is
  // where you switch discipline now. Absent (opened without the tree), every
  // licensed tab still shows.
  const focusedEquipmentTab = searchParams.get("equipmentTab");

  const buildLegacyTabs = (parentType, parentTabIndex) => [
    {
      label: "Estimation",
      panel: (
        <EstimationTab
          plant={props.plant}
          parentTabIndex={parentTabIndex}
          parentType={parentType}
        />
      ),
    },
    {
      label: "Estimation Summary",
      panel: (
        <EstimationSummaryTab
          plant={props.plant}
          parentTabIndex={parentTabIndex}
          parentType={parentType}
        />
      ),
    },
    {
      label: "Estimation BOM",
      panel: (
        <EstimationBOMTab
          plant={props.plant}
          parentTabIndex={parentTabIndex}
          parentType={parentType}
        />
      ),
    },
  ];

  const equipmentTabs = useMemo(() => {
    const licensedTabs = filterEstimationTabsByLicence(
      [
          {
            key: "structure",
            label: "Structure",
            panel: (
              <GeneralProvider>
                <Modeling />
              </GeneralProvider>
            ),
          },
          {
            key: "piping",
            label: "Piping",
            panel: (
              <GeneralProvider>
                <Piping />
              </GeneralProvider>
            ),
          },
          {
            key: "instrumentation",
            label: "Instrumentation",
            panel: (
              <GeneralProvider>
                <Instrumentation />
              </GeneralProvider>
            ),
          },
          {
            key: "pv",
            label: "Pressure Vessel",
            panel: (
              <GeneralProvider>
                <PVModeling />
              </GeneralProvider>
            ),
          },
      ],
      hasModule,
    );

    if (!focusedEquipmentTab) return licensedTabs;

    // Fall back to the full set if the link names a tab this licence doesn't
    // include - better a wrong-looking tab strip than an empty page.
    const focused = licensedTabs.filter(
      (tab) => tab.label === focusedEquipmentTab,
    );
    return focused.length ? focused : licensedTabs;
  }, [hasModule, focusedEquipmentTab]);

  const showLegacyEstimation =
    !props.plant &&
    (hasModule(APP_MODULES.ESTIMATION) ||
      hasModule(APP_MODULES.ESTIMATION_STRUCTURE));

  return (
    <Box className="estimation-auto-tabs-root" sx={autoResizeTabsSx}>
      <GlobalStyles
        styles={{
          ".estimation-auto-tabs-root .MuiTabs-root": {
            minHeight: "0px !important",
            height: "auto !important",
          },

          ".estimation-auto-tabs-root .MuiTabs-scroller": {
            minHeight: "0px !important",
            height: "auto !important",
          },

          ".estimation-auto-tabs-root .MuiTabs-flexContainer": {
            minHeight: "0px !important",
            height: "auto !important",
            alignItems: "center !important",
          },

          ".estimation-auto-tabs-root .MuiTab-root": {
            minHeight: "0px !important",
            height: "auto !important",
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
            paddingLeft: "12px !important",
            paddingRight: "12px !important",
            fontSize: "12px !important",
            fontWeight: "600 !important",
            lineHeight: "1.2 !important",
            textTransform: "none !important",
          },

          ".estimation-auto-tabs-root .MuiTabs-indicator": {
            height: "2px !important",
          },

          // One height for every button inside this container, so the module
          // headers keep Save and Compare Revisions level with each other.
          ".estimation-auto-tabs-root .MuiButton-root": {
            minHeight: "0px !important",
            height: "auto !important",
            paddingTop: "5px !important",
            paddingBottom: "5px !important",
            fontSize: "12px !important",
            lineHeight: "1.2 !important",
            textTransform: "none !important",
          },

          // Save is the primary action and its label swaps to “Saving…”, so it
          // gets a stable width — but no height of its own.
          ".estimation-auto-tabs-root .MuiButton-root.header-save-btn": {
            minWidth: "76px !important",
            paddingLeft: "12px !important",
            paddingRight: "12px !important",
          },

          ".estimation-auto-tabs-root .MuiInputBase-root": {
            minHeight: "0px !important",
            height: "auto !important",
            fontSize: "12px !important",
          },

          ".estimation-auto-tabs-root .MuiInputBase-input": {
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
            fontSize: "12px !important",
            lineHeight: "1.2 !important",
          },

          ".estimation-auto-tabs-root .MuiSelect-select": {
            minHeight: "0px !important",
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
            display: "flex !important",
            alignItems: "center !important",
          },

          ".estimation-auto-tabs-root .MuiAutocomplete-root .MuiOutlinedInput-root":
            {
              minHeight: "0px !important",
              height: "auto !important",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            },

          ".estimation-auto-tabs-root .MuiAutocomplete-root .MuiAutocomplete-input":
            {
              paddingTop: "6px !important",
              paddingBottom: "6px !important",
              fontSize: "12px !important",
              lineHeight: "1.2 !important",
            },

          ".estimation-auto-tabs-root .MuiToolbar-root": {
            minHeight: "0px !important",
            height: "auto !important",
            paddingTop: "4px !important",
            paddingBottom: "4px !important",
          },
        }}
      />

      {props.plant && (
        <Box sx={mainEquipmentTabsSx}>
          {equipmentTabs.length ? (
            <NavTabs
              tabs={equipmentTabs}
              navLabel="structure-piping-pressure-vessel-tab"
            />
          ) : (
            <Alert severity="warning" sx={{ m: 2 }}>
              Your licence does not include any estimation equipment modules
              (Structure, Piping, or Pressure Vessel).
            </Alert>
          )}
        </Box>
      )}

      {showLegacyEstimation && (
        <NavTabs tabs={buildLegacyTabs("struc", 0)} navLabel="est-tab" />
      )}
    </Box>
  );
};

export default Estimation;